import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  PaymentActionError,
  PaymentActionResult,
  ProcessPaymentPayload,
} from '@cashier/cashier-model';

export interface PaymentProcessingState {
  result: PaymentActionResult;
  error: null | PaymentActionError;
  isProcessingLoading: boolean;
}

export const PAYMENT_PROCESSING_FEATURE_KEY = 'paymentProcessing';

export const initialPaymentProcessingState: PaymentProcessingState = {
  result: {
    status: '',
    resultAction: null,
    description: '',
    transactionId: '',
    paymentAttributes: [],
  },
  error: null,
  isProcessingLoading: false,
};

export const paymentProcessingSlice = createSlice({
  name: PAYMENT_PROCESSING_FEATURE_KEY,
  initialState: initialPaymentProcessingState,
  reducers: {
    resetStore: (state) => {
      state.result = {
        ...initialPaymentProcessingState.result,
      };
      state.isProcessingLoading = false;
    },
    initiateProcessing: (state) => {},
    processPaymentStart: (
      state,
      action: PayloadAction<ProcessPaymentPayload>,
    ) => {
      state.isProcessingLoading = true;
    },
    processPaymentSuccess: (
      state,
      action: PayloadAction<PaymentActionResult>,
    ) => {
      state.result = action.payload;
      state.isProcessingLoading = false;
    },
    processPaymentFailure: (
      state,
      action: PayloadAction<PaymentActionError>,
    ) => {
      state.error = action.payload;
      state.isProcessingLoading = false;
    },
    toggleProcessingLoading: (state, action: PayloadAction<boolean>) => {
      state.isProcessingLoading = action.payload;
    },
  },
});

export const paymentProcessingReducer = paymentProcessingSlice.reducer;

export const {
  initiateProcessing,
  processPaymentStart,
  processPaymentSuccess,
  processPaymentFailure,
  resetStore,
  toggleProcessingLoading,
} = paymentProcessingSlice.actions;
